import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Dispatch, ReactElement, SetStateAction, useState } from 'react';

import { IOption } from '~/types';
import styles from './SimpleSelect.module.scss';

interface IProps {
  value: number;
  label: string;
  options: IOption[];
  setValue: (value: number) => void | Dispatch<SetStateAction<number>>;
}

const SimpleSelect = ({ value, options, label, setValue }: IProps): ReactElement => {
  const [open, setOpen] = useState(false);

  const handleChange = (event: SelectChangeEvent<number>) => {
    setValue(event.target.value as number);
  };

  const renderItem = (item: IOption) => (
    <MenuItem key={item.value} value={item.value}>
      {item.label}
    </MenuItem>
  );

  return (
    <Grid container spacing={1} className={styles.container}>
      <Grid
        size={{
          sm: 12,
        }}
      >
        <FormControl variant="outlined" fullWidth size="small">
          <InputLabel id="label-select">{label}</InputLabel>
          <Select
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
            open={open}
            MenuProps={{
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            }}
            labelId="label-select"
            id={label}
            value={value}
            label={label}
            onChange={handleChange}
            IconComponent={() =>
              open ? (
                <ExpandLessIcon className={styles.arrow} color="secondary" />
              ) : (
                <ExpandMoreIcon className={styles.arrow} color="secondary" />
              )
            }
          >
            {options.map(renderItem)}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default SimpleSelect;
